import React from "react";
import { Button, Stack, Typography } from "@mui/material";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import RefreshRoundedIcon from "@mui/icons-material/RefreshRounded";

export default function RecurringInvoiceHeader({ onRefresh, onCreate }) {
    return (
        <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={2} sx={{ mb: 3 }}>
            <Typography variant="h4">Abo- &amp; wiederkehrende Rechnungen</Typography>
            <Stack direction="row" spacing={1}>
                <Button startIcon={<RefreshRoundedIcon />} onClick={onRefresh} variant="outlined">
                    Aktualisieren
                </Button>
                <Button startIcon={<AddRoundedIcon />} variant="contained" onClick={onCreate}>
                    Neues Abo
                </Button>
            </Stack>
        </Stack>
    );
}
